module.exports = __webpack_public_path__ + "static/media/mobileProgramsTile@2x.48becdab.svg";